import React from "react";
import { Grid, Box } from "@mui/material";
import { CanvasCardStyle as styles } from "./styles";
import { TextView } from "@components";
import { useEditor } from "@craftjs/core";

const Card = ({ data = [], backgroundColor }) => {
  const { connectors } = useEditor();
  return (
    <Grid container spacing={1} style={{ marginTop: "8px", cursor: "grab" }}>
      {data?.length ? (
        data.map((d) => (
          <>
            <Grid key={d?.id} item xs={12} sm={4} md={4}>
              <Box
                sx={styles.boxStyle(backgroundColor)}
                ref={(ref) => connectors.create(ref, d?.component)}
                data-cy={d?.dataCy}
              >
                <img src={d?.image} height={24} width={20} alt="Tool Icon" />
                <TextView
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: 400,
                  }}
                >
                  {d?.title}
                </TextView>
              </Box>
            </Grid>
          </>
        ))
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default Card;
